/**
 * Publisher-facing payout headline formatting.
 *
 * Siteplug (Affise) brands are assigned as passthrough and historically
 * stored upstream rates as ``6 USD (percent)``. Normalise those legacy
 * strings plus structured fields into ``6%`` or ``6 USD``.
 */

function formatNum(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return "";
  return x % 1 === 0 ? String(Math.trunc(x)) : String(x);
}

/** Parse legacy Affise strings like ``6 USD (percent)`` / ``4 USD (fix)``. */
function parseLegacySiteplugPayout(raw) {
  const s = String(raw || "").trim();
  const m = s.match(/^([\d.]+)\s+([A-Za-z]{3})\s*\((\w+)\)$/i);
  if (!m) return null;
  const [, val, cur, typ] = m;
  if (typ.toLowerCase() === "percent") return `${formatNum(val)}%`;
  return `${formatNum(val)} ${cur.toUpperCase()}`;
}

export function formatSiteplugPayout(b) {
  const legacy = parseLegacySiteplugPayout(b.payout_display)
    || parseLegacySiteplugPayout(b.headline_payout);
  if (legacy) return legacy;

  const shape = (b.payout_shape || "").toLowerCase();
  const cur = (b.currency || "USD").toUpperCase();
  const pct = b.custom_commission_pct ?? b.base_commission_pct;
  const flat = b.pub_flat_amount ?? b.payout_amount ?? b.flat_cpa_amount ?? b.payout;

  if (shape === "percent") {
    if (pct != null && Number(pct) > 0) return `${formatNum(pct)}%`;
  }
  if (shape === "flat") {
    if (flat != null && Number(flat) > 0) return `${formatNum(flat)} ${cur}`;
  }

  const raw = (b.headline_payout || b.payout_display || b.rates_summary || "").trim();
  if (raw && !/\([\w]+\)$/.test(raw)) return raw;
  return raw || "See details";
}
